/**
 * Single JS (detail page).
 */
// Instantiate components
// Components
import { ComponentManager } from 'js-component-framework';
import sidebar from 'components/sidebar';
import mediaTrigger from 'components/mediaTrigger';

// Create instance of the component manager using `kauffman`
const manager = new ComponentManager('kauffman');

// Initialize components
document.addEventListener('DOMContentLoaded', () => {
  manager.initComponents([
    mediaTrigger,
    sidebar,
  ]);
});

if (module.hot) {
  module.hot.accept();
  manager.initComponents([
    mediaTrigger,
    sidebar,
  ]);
}

